<template>
  <page-layout class="timeline" ref="page">

    <div class="title">
      <div class="title_top">
        <p>Timeline</p>
      </div>
    </div>

    <div class="inner">

      <article class="results_lst">


        <div ref="lists">
          <!-- 리스트/토너먼트 -->
          <div class="list tnmt">
            <!-- basic view -->
            <div class="timeline_results">
              <div class="regions">
                <div class="asia"><p>Asia-Pacific</p></div>
                <div class="am-eu"><p>Americas/Europe</p></div>
              </div>
              <template v-for="(tournamentGroup, index) in queryTournamentsData">
                <div :key="tournamentGroup.date + index" class="timeline_wrap">
                  <div class="title_wrap">
                    <h3 v-html="getDateText(tournamentGroup.date)"></h3>
                  </div>
                  <div v-for="(tournament, index) in tournamentGroup.row" :key="`${tournament.idx}`" class="ctnr_wrap">
                    <div class="timeline_ctnr" @click="goDetail(tournament)" :class="{'asia': tournament.region_name == 'Asia-Pacific', 'am-eu': tournament.region_name == 'Americas' || tournament.region_name == 'Europe'}">
                      <div class="brand">
                        <div class="img"><img v-if="isFileExist(tournament.brand_logo_img)" :src="tournament.brand_logo_img.url"></div>
                      </div>
                      <p v-if="tournament.period === 'O'" class="ongo">Now Ongoing<span class="shimmer"></span></p>
                      <div class="cont">
                        <h5 v-html="tournament.title"></h5>
                        <h6 class="loc"><span class="flag" v-if="tournament.flag_code"><img :src="`/statics/img/flags/${tournament.flag_code}.svg`"></span>{{ tournament.venue }}<span v-if="!isMobile">{{ tournament.country_name && `, ${tournament.country_name}` }}</span></h6>
                        <p class="date">{{ tournament.date }}</p>
                        <div class="badge">
                          <span class="live" v-if="tournament.is_reporting"><img src="https://api.card-gorilla.com:8080/storage/corp/2/tips/28950/tips_lr.png"></span>
                          <span class="live" v-if="tournament.is_coverage"><img src="https://api.card-gorilla.com:8080/storage/corp/3/tips/31556/tips_nc.png"></span>
                        </div>
                      </div>
                      <div class="venue">
                        <div class="img"><img class="fit_img" v-if="isFileExist(tournament.poster_img)" :src="tournament.poster_img.url"><img v-else class="fit_img empty" :src="tournament.brand_logo_img.url"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

          </div>
        </div>

      </article>

    </div>

  </page-layout>
</template>

<script>
  import { Dialog, Loading, Select, Option, OptionGroup, Slider, Button, Checkbox, CheckboxButton, CheckboxGroup } from 'element-ui'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import commonComputed from 'src/_mixins/CommonComputed'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import VueScrollTo from "vue-scrollto";
  export default {
    name: "Timeline",
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer,
      [Dialog.name]: Dialog,
      [Select.name]: Select,
      [Option.name]: Option,
      [OptionGroup.name]: OptionGroup,
      [Slider.name]: Slider,
      [Button.name]: Button,
      [CheckboxGroup.name]: CheckboxGroup,
      [CheckboxButton.name]: CheckboxButton,
      [Checkbox.name]: Checkbox,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Timeline`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `A visual timeline of ongoing and upcoming poker tournaments`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Timeline | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `A visual timeline of ongoing and upcoming poker tournaments`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        searchQuery: {},
        searchQueryOrigin: {
          region_idx: [1, 44, 45],
          // country_idx: '',
          brand_idx: '',
          date: moment().format('YMM'),
          period: ['O','U'],
          view_mode: ''
        },
        loading: {},
        sortTournaments: {
          key: 'date',
          asc: true
        },
        sortEvents: {
          key: 'date',
          asc: true
        },
        reA: /[^a-zA-Z-\s]/g,
        reN: /[^0-9]/g
      }
    },
    created() {
      this.searchQuery = this.cloneData(this.searchQueryOrigin)
      this.$store.dispatch('callDatePeriod')
      this.$store.dispatch('callRegionCountries')
      this.$store.dispatch('callBrands')
    },
    activated () {
      this.$nextTick(async () => {
        await this.getRouteQuery()
        await this.$store.dispatch('callTournaments')
      })
    },
    computed: {
      ...commonComputed,
      ...mapGetters([
        'getRegionCountries',
        'getBrands',
        'getTournaments',
        'getEvents',
        'getDatePeriod',
        'makeKey'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      isPrevMonthPossible () {
        return Number(this.searchQuery.date) > Number(moment(this.getDatePeriod.start_date).format('YMM'))
      },
      isNextMonthPossible () {
        return Number(this.searchQuery.date) < Number(moment(this.getDatePeriod.end_date).format('YMM'))
      },
      isCompactView () {
        return this.searchQuery.view_mode === 'compact'
      },
      queryTournamentsData () {
        if (!this.searchQuery.date) return []
        if (this.getTournaments.data.length === 0) return []

        const ownData = this.cloneData(this.queryTournamentsOwnData)
        const filterPeriods = this.searchQuery.period || []
        const currentDate = this.getNumberTime(moment())
        let data = null

        if (this.searchQuery.date.length === 4) {
          data = Array.from({ length: 12 }, (_, i) => ({ date: Number(this.getCurrentYear + String(i+1).padStart(2, '0')), row: {} }))
        } else {
          const startTime = moment(this.searchQuery.date)
          const allEndTimes = ownData.map(obj => moment(obj.end_time))
          let endTime = moment.max(allEndTimes)
          endTime = endTime.add(1, 'months')
          let currentTime = startTime
          data = Array.from({ length: endTime.diff(startTime, 'months') }, () => {
            const rtn = { date: this.getNumberTimeMonth(currentTime.format('Y-MM-DD')), row: {} }
            currentTime = currentTime.add(1, 'months')
            return rtn
          })
        }

        return data.map((d) => {
          d.row = ownData.filter(row => {
            const rowStartMonth = this.getNumberTimeMonth(row.start_time)
            const rowEndMonth = this.getNumberTimeMonth(row.end_time)
            const rowStartDate = this.getNumberTime(row.start_time)
            const rowEndDate = this.getNumberTime(row.end_time)

            const isRightMonth = rowStartMonth <= d.date && d.date <= rowEndMonth
            const isOngoing = isRightMonth && rowStartDate <= currentDate && currentDate <= rowEndDate
            const isUpcoming = isRightMonth && rowStartDate > currentDate && rowEndDate > currentDate
            const isCompleted = isRightMonth && rowEndDate < currentDate

            let includeRow = false

            if (filterPeriods.includes('O') && isOngoing) { includeRow = true; row.period = 'O' }
            if (filterPeriods.includes('U') && isUpcoming) { includeRow = true; row.period = 'U' }
            if (filterPeriods.includes('C') && isCompleted) { includeRow = true; row.period = 'C' }

            return includeRow
          })
          return d
        }).filter(row => row.row.length > 0)
      },
      queryTournamentsDataCompact () {
        const data = this.cloneData(this.queryTournamentsOwnData)
        const filterPeriods = this.searchQuery.period || []
        const currentDate = this.getNumberTime(moment())
        return data.filter(row => {
          const rowStartDate = this.getNumberTime(row.start_time)
          const rowEndDate = this.getNumberTime(row.end_time)

          const isOngoing = rowStartDate <= currentDate && currentDate <= rowEndDate
          const isUpcoming = rowStartDate > currentDate && rowEndDate > currentDate
          const isCompleted = rowEndDate < currentDate

          let includeRow = false

          if (filterPeriods.includes('O') && isOngoing) { includeRow = true; row.period = 'O' }
          if (filterPeriods.includes('U') && isUpcoming) { includeRow = true; row.period = 'U' }
          if (filterPeriods.includes('C') && isCompleted) { includeRow = true; row.period = 'C' }

          return includeRow
        })
      },
      queryTournamentsOwnData () {
        if (this.getTournaments.data.length === 0) return []
        return this.sortTournaments.asc
            ? this.getTournaments.data.sort((a, b) => this.sortAlphaNum(a[this.sortTournaments.key], b[this.sortTournaments.key]))
            : this.getTournaments.data.sort((a, b) => this.sortAlphaNum(b[this.sortTournaments.key], a[this.sortTournaments.key]))
      },
      queryEventsData () {
        return this.sortEvents.asc
            ? this.getEvents.data.sort((a, b) => this.sortAlphaNum(a[this.sortEvents.key], b[this.sortEvents.key]))
            : this.getEvents.data.sort((a, b) => this.sortAlphaNum(b[this.sortEvents.key], a[this.sortEvents.key]))
      }
    },
    methods: {
      ...CommonMethods,
      getNumberTimeMonth (strDate) {
        return Number(moment(strDate).format('YMM'))
      },
      getNumberTime (strDate) {
        return Number(moment(strDate).format('YMMDD'))
      },
      sortAlphaNum(a, b) {
        const aA = a.toString().replace(this.reA, '');
        const bA = b.toString().replace(this.reA, '');
        if (aA === bA) {
          const aN = parseInt(a.toString().replace(this.reN, ''), 10);
          const bN = parseInt(b.toString().replace(this.reN, ''), 10);
          return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
          return aA > bA ? 1 : -1;
        }
      },
      getRouteQuery () {
        this.searchQuery = Object.keys(this.searchQuery).length > 0 ? this.cloneData(this.searchQuery) : this.cloneData(this.searchQueryOrigin)
        let query = this.cloneData(this.$route.query)
        if (query) {
          Object.keys(this.searchQuery).map(key => {
            if (query[key]) {
              if (key === 'date') {
                let date
                let raw = query[key]
                if (raw.length === 4) {
                  date = moment(raw, 'YYYY', true)
                } else {
                  date = moment(raw.length === 6 ? raw + '01' : raw)
                }
                query[key] = raw.length === 4 ? date.format('Y') : date.format('YMM')
              }
              if (key === 'region_idx') {
                this.searchQuery[key] = query[key].split(',').map(row => Number(row))
              } else if (key.substr(-3) === 'idx') {
                this.searchQuery[key] = Number(query[key])
              } else if (key === 'view_mode' && query[key] === 'compact') {
                this.searchQuery[key] = query[key]
              } else if (key === 'period') {
                this.searchQuery[key] = query[key].split(',')
              } else {
                this.searchQuery[key] = query[key]
              }
            }
          })
          this.setRouteQueryFromSearchQuery()
        }
      },
      setRouteQueryFromSearchQuery () {
        const query = this.cloneData(this.searchQuery)
        query['period'] = query['period'].join(',')
        query['region_idx'] = query['region_idx'].join(',')
        this.$router.replace({ path: this.$route.path, query: query })
      },
      isRightDatePeriod (date = this.searchQuery.date) {
        if (date.length === 4) {
          date = Number(date)
          const start = Number(this.getDatePeriod.start_date.substring(0, 4))
          const end = Number(this.getDatePeriod.end_date.substring(0, 4))
          return date >= start && date <= end
        } else {
          return moment(date).isBetween(this.getDatePeriod.start_date, this.getDatePeriod.end_date)
        }
      },
      getDateText (date = '') {
        if (date.toString().indexOf('-') > -1) {
          date = date.replace(/\-/g, '').substring(0, 6)
        }
        if (date.length === 4) date = date + this.getMonthOptions[this.getMonthOptions.length-1]
        const y = date ? moment(date + '15').format('YYYY') : ''
        const monthFormat = this.getAccess === 'mobile' ? 'MMM' : 'MMMM'
        const m = date ? moment(date + '15').format(monthFormat) : ''
        return `<p class="month">${m}</p> ${y}`
      },
      getDateEng () {

      },
      matchSortValue (val) {
        return Number(val.match(/(\d+)/g)[0])
      },
      reset () {
        this.regionCountry = ''
        this.searchQuery = this.cloneData(this.searchQueryOrigin)
        this.setRouteQueryFromSearchQuery()
      },
      sort (key) {
        const obj = this.sortTournaments
        obj.key === key ? obj.asc = !obj.asc : obj.key = key
      },
      goDetail (row) {
        this.$router.push({path: `/tournament/${row.idx}`})
      },
    }
  }
</script>

<style scoped>
  .timeline {
    position: relative;
    top: -40px;
  }
  .timeline .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 10px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .list {
    margin-top: 20px;
  }
  .list .timeline_results {
    position: relative;
  }
  .list .timeline_results .regions {
    position: sticky;
    top: 60px;
    width: 100%;
    height: 70px;
    background: rgba(255,255,255,0.75);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid #000;
    z-index: 3;
    margin-bottom: -60px;
  }
  .list .timeline_results .regions div {
    display: inline-block;
    width: 50%;
    height: 100%;
    text-align: center;
  }
  .list .timeline_results .regions div p {
    position: relative;
    display: inline-block;
    font-size: 22px;
    font-weight: 600;
    color: #005e02;
    letter-spacing: -0.04em;
    line-height: 1.0em;
    padding: 15px 50px;
    border-radius: 5.0em;
    margin-top: 8px;
  }
  .list .title_wrap {
    position: sticky;
    top: 70px;
    z-index: 4;
  }
  .list h3 {
    font-size: 16px;
    font-weight: 400;
    color: rgba(255,255,255,0.75);
    letter-spacing: -0.02em;
    line-height: 1.3em;
    display: inline-flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    background: #005e02;
    border: 4px solid #008c03;
    border-radius: 100%;
    padding: 5px 20px 0;
    margin: 0 0 40px 0;
  }
  .list h3 /deep/.month {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
  }
  .list .timeline_wrap {
    position: relative;
    text-align: center;
    padding-bottom: 50px;
  }
  .list .timeline_wrap:before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 30px;
    background: linear-gradient(180deg, rgba(0,140,3,1.0), rgba(0,140,3,0.0));
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translate(-2px, 0);
    z-index: 1;
  }
  .list .timeline_wrap:after {
    content: "";
    display: inline-block;
    width: 4px;
    height: 100%;
    background: #008c03;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .list .ctnr_wrap {
    position: relative;
  }
  .list .ctnr_wrap:before {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 7px solid #008c03;
    border-radius: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .list .timeline_ctnr {
    position: relative;
    padding: 24px 24px 24px 168px;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 8px;
    display: flex;
    align-items: center;
    width: 44%;
    min-height: 130px;
    text-align: left;
    z-index: 1;
    transition: .15s;
  }
  .list .timeline_ctnr:after {
    content: "";
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #fff;
    position: absolute;
    right: -10px;
    transform: rotate(45deg);
    transition: .15s;
  }
  .list .timeline_ctnr.am-eu {
    margin-left: calc(56%);
    padding: 24px 24px 24px 135px;
  }
  .list .timeline_ctnr.am-eu:after {
    left: -10px;
    right: unset;
  }
  .list .timeline_ctnr .ongo {
    position: absolute;
    top: 15px;
    left: 15px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    line-height: 1.0em;
    background: #dd0000;
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    overflow: hidden;
    z-index: 1;
  }
  .list .timeline_ctnr.am-eu .ongo {
    left: unset;
    right: 15px;
  }
  .shimmer {
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-25deg);
    animation: light-swipe 1.8s infinite ease-in-out;
  }
  @keyframes light-swipe {
    0% {
      left: -200%;
    }
    100% {
      left: 200%;
    }
  }
  .list .timeline_ctnr .brand {
    position: absolute;
    right: 24px;
    display: inline-block;
  }
  .list .timeline_ctnr.am-eu .brand {
    left: 24px;
  }
  .list .timeline_ctnr .brand .img {
    position: relative;
    width: 90px;
    height: 90px;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
  }
  .list .timeline_ctnr .brand .img:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 1;
  }
  .list .timeline_ctnr .brand .img img {
    max-width: 100%;
    border-radius: 5px;
  }
  .list .timeline_ctnr .cont {
    position: relative;
    display: inline-block;
    width: 68.5%;
    text-align: right;
  }
  .list .timeline_ctnr.am-eu .cont {
    width: 65%;
    text-align: left;
  }
  .list .timeline_ctnr .cont h5 {
    font-family: 'Montserrat';
    font-size: 18px;
    font-weight: 700;
    color: #000;
    letter-spacing: -0.03em;
    line-height: 1.15em;
  }
  .list .timeline_ctnr .cont p.date {
    font-size: 16px;
    font-weight: 500;
    color: #888;
    letter-spacing: -0.03em;
    line-height: 1.0em;
    padding: 6px 0 0 0;
  }
  .list .timeline_ctnr .cont .loc {
    font-size: 13.5px;
    font-weight: 400;
    color: rgba(0,0,0,0.8);
    letter-spacing: -0.015em;
    display: inline-flex;
    align-items: center;
  }
  .list .timeline_ctnr .cont .loc .flag {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 12px;
    margin-right: 8px;
  }
  .list .timeline_ctnr .cont .loc .flag:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    z-index: 1;
  }
  .list .timeline_ctnr .cont .loc .flag img {
    max-width: 100%;
    max-height: 100%;
  }
  .list .timeline_ctnr .cont .badge {

  }
  .list .timeline_ctnr.am-eu .cont .badge {
    left: unset;
  }
  .list .timeline_ctnr .cont .live {
    position: relative;
    display: inline-block;
    height: 20px;
    margin: 10px 2px 0 0;
  }
  .list .timeline_ctnr .cont .live img {
    max-width: 100%;
    max-height: 100%;
  }
  .list .timeline_ctnr .venue {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 100%;
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    background: #333;
  }
  .list .timeline_ctnr.am-eu .venue {
    left: unset;
    right: 0;
    border-radius: 0 8px 8px 0;
  }
  .list .timeline_ctnr .venue .img {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .list .timeline_ctnr .venue .img img {
    object-fit: cover;
  }
  .list .timeline_ctnr .venue .img img.empty {
    filter: blur(15px) opacity(0.45);
  }
  .list .timeline_ctnr:hover {
    background: #e5ede8;
  }
  .list .timeline_ctnr:hover:after {
    background: #e5ede8;
  }
  .list .timeline_ctnr:hover .btn {
    color: #fff;
    background: #e5ede8;
  }
  .p-hide {
    display: none !important;
  }
  /deep/ .el-loading-spinner .path { stroke: #000; }

  /* on wallpaper */
  #q-app.wallpaper .timeline_ctnr,
  #q-app.wallpaper .timeline_ctnr:after {
    background: #f5f5f5;
  }
  #q-app.wallpaper .timeline_ctnr:hover,
  #q-app.wallpaper .timeline_ctnr:hover:after {
    background: #e5ede8;
  }
</style>
